import { Pipe, PipeTransform, Input } from '@angular/core';
//Pipe para hacer buscadores desde el cliente
@Pipe({
  name: 'search'
})
export class GenericSearchPipe implements PipeTransform {
    transform(value: Array<any>, args?: any): any {
        //Si no hay una cadena retornamos todo el array
        if(!args) return value;
        //Si no nos pasan un array devolvemos el objeto
        if(!value.filter) return value;
        //Convertimos todo en minusculas en la cadena de busqueda
        args = args.toLocaleLowerCase();
        //Buscamos por cada uno de los indices del aray
        const lista = value.filter((value,index)=>{
            //Inicializamos la variable que nos dice si encontró algo
            let condicion:boolean;
            //Recorremos cada una de las propiedades del objeto en el que estamos
            for(let campo in value){
                //Si el valor es nulo pasamos este registro
                if(value[campo] === null) continue;
                //Si en el campo no existe el metodo tolocallowercase significa que no es ni numeros ni un string
                if(value[campo].toLocaleLowerCase === undefined )continue;
                //Convertimos esta propiedad en minusculas y la guardamos en una variable temporal
                var temp = value[campo].toLocaleLowerCase() || "";
                //Verificamos si coincide
                condicion = temp.indexOf(args) > -1;
                //Si encontramos algo dejamos de iterar
                if(condicion) break;
            }
            //Retornamos si encontró algo
            return condicion;
        })
        // Devolvemos la lista de coincidencias
        return lista;
    }

}
